import React from "react";
import type { PhotoStatus } from "./photoUpdateApi";
import { photoBadge, photoMeta } from "./photoStatus";

const Camera = () => (
  <svg viewBox="0 0 24 24" width={13} height={13} fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M4 8h3l1.6-2.2h6.8L17 8h3v11H4Z" />
    <circle cx="12" cy="13.3" r="3.3" />
  </svg>
);

const Stack = () => (
  <svg viewBox="0 0 24 24" width={13} height={13} fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <rect x="7" y="7" width="13" height="13" rx="2" />
    <path d="M4 16V5a1 1 0 0 1 1-1h11" />
  </svg>
);

/**
 * "Needs photo" (amber, camera) or "Photos to review" (blue, stack) on a product card or row. Text plus icon,
 * never colour alone; the reason and age sit in the accessible name and the tooltip. Nothing when no photo is
 * needed or photo updates are off (the row then has no photoStatus).
 */
const NeedsPhotoBadge = ({ status, withMeta = false, over = false }: { status?: PhotoStatus | null; withMeta?: boolean; over?: boolean }) => {
  const badge = photoBadge(status);
  if (!badge) return null;
  const meta = photoMeta(status);
  return (
    <span className={`pu-badge is-${badge.kind}${over ? " is-over" : ""}`} aria-label={badge.aria} title={meta || undefined}>
      {badge.kind === "review" ? <Stack /> : <Camera />}
      <span className="pu-badge__label">{badge.label}</span>
      {withMeta && meta ? <span className="pu-badge__meta">{meta}</span> : null}
    </span>
  );
};

export default NeedsPhotoBadge;
